import React from "react"
import HubspotForm from "react-hubspot-form"
import Link from "../components/link"
import { htmlDecode } from "../Utils"

const FormContent = ({
  key,
  formPosition="left",
  formTitle=null,
  form=null,
  title=null,
  containsVideo=false,
  content=null,
  video=null
}) => {
  let formId = null
  if (form) {
    const split1 = form.split('formId:')
    const split2 = split1[1].split("\n")
    formId = split2[0].replaceAll('"', '')
  }

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      <div className="form_with_content_block pb5">
        <div className="container">
          <div className="row">
            <div className={ `col-sm-12 col-lg-6 ${formPosition === 'left' ? "flex-last" : ""}` }>
              {title &&
                <h2 className="form_with_content_block__content-title mt4 mb4">{ htmlDecode(title) }</h2>
              }
              {containsVideo &&
                <div className="form_with_content_block__content-video mb4">
                  {video.videoSource === 'wistia' &&
                    <div className="img-container linked">
                      <div className={ `wistia_embed wistia_async_${video.videoId} popover=true popoverAnimateThumbnail=true popoverContent=link videoFoam=true` }>
                        <div className="play-btn-wrap"><div className="play-btn"><span className="fa fa-play"></span></div></div>
                        {video.videoThumbnail.formats?.medium &&
                          <img src={video.videoThumbnail.formats.medium.url.includes(cdnUrl) ? video.videoThumbnail.formats.medium.url : cdnUrl + video.videoThumbnail.formats.medium.url} alt={ video.videoThumbnail.alternativeTest } className="form_with_content_block__content-video__video-screenshot" />
                        }
                        {!video.videoThumbnail.formats?.medium &&
                          <img src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail.alternativeTest } className="form_with_content_block__content-video__video-screenshot" />
                        }
                      </div>
                    </div>
                  }
                  {video.videoSource === 'youtube' &&
                    <div className="img-container linked">
                      <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal" data-target={ `#video-${video.videoId}` }><span className="fa fa-play"></span></a>
                      </div>
                      {video.videoThumbnail.formats?.medium &&
                        <img src={video.videoThumbnail.formats.medium.url.includes(cdnUrl) ? video.videoThumbnail.formats.medium.url : cdnUrl + video.videoThumbnail.formats.medium.url} alt={ video.videoThumbnail.alternativeTest } className="form_with_content_block__content-video__video-screenshot" />
                      }
                      {!video.videoThumbnail.formats?.medium &&
                        <img src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail.alternativeTest } className="form_with_content_block__content-video__video-screenshot" />
                      }
                    </div>
                  }
                </div>
              }
              {content &&
                <div className="form_with_content_block__content-text section-content" dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
            <div className={ `col-sm-12 col-lg-6 no-gutter-lg-left subform sub78 asc ${formPosition === 'left' ? "flex-first" : ""}` }>
              <div className={ `form_with_content_block__form-wrap ${formPosition === 'right' ? "form-last" : ""}` }>
                {formTitle &&
                  <h2 className="form_with_content_block__form-title ft8">{ htmlDecode(formTitle) }</h2>
                }
                {form && formId &&
                  <div className="pt3 ph6 pb5 tac">
                    <HubspotForm
                        portalId="2718424"
                        css=""
                        cssClass="hbspt-form"
                        region="na1"
                        formId={ formId }
                        loading={ <div className="form-loading"><h3>Loading...</h3></div> }
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {containsVideo && video.videoSource === 'youtube' &&
        <div className="modal fade content-video-modal" id={ `video-${video.videoId}` } tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe src={ `https://www.youtube.com/embed/${video.videoId}` } playing="true" height="720px" className="embed-responsive-item" />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default FormContent
